module.exports = __webpack_public_path__ + "static/media/border-left.4657d53c.svg";